<template>
  <div 
    class="expandable-container" 
    :class="{ 'is-expanded': isExpanded, 'can-expand': canExpand }"
  >
    <div 
      ref="textContent" 
      class="content" 
      @click="toggle"
    >
      <slot></slot>
    </div>
    <span v-if="canExpand" class="arrow" @click="toggle">▼</span>
  </div>
</template>

<script>
export default {
  name: 'ExpandableText',
  props: {
    initialExpanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: this.initialExpanded,
      canExpand: false
    };
  },
  methods: {
    checkOverflow() {
      const el = this.$refs.textContent;
      if (el) {
        // Если уже развернуто, считаем что расширять можно (для показа стрелки)
        if (this.isExpanded) {
          this.canExpand = true;
          return;
        }
        this.canExpand = el.scrollHeight > el.offsetHeight;
      }
    },
    toggle() {
      if (!this.canExpand) return;

      // Защита от сворачивания при выделении текста
      const selection = window.getSelection();
      if (selection && selection.toString().length > 0) {
        return;
      }

      this.isExpanded = !this.isExpanded;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkOverflow();
    });
    window.addEventListener('resize', this.checkOverflow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkOverflow);
  }
};
</script>

<style scoped>
.expandable-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; 
  line-clamp: 1;
}

.can-expand .content {
  cursor: pointer;
}

.is-expanded .content {
  display: block; 
  -webkit-line-clamp: none;
  line-clamp: none;
  overflow: visible;
}

.arrow {
  font-size: 10px;
  padding-top: 5px;
  cursor: pointer;
  transition: transform 0.3s;
  flex-shrink: 0;
  user-select: none;
}

.is-expanded .arrow {
  transform: rotate(180deg);
}
</style>